<template>
  <div class="file_card">
    <el-tooltip class="box-item" effect="dark" :content="fileData.path || fileData.msgContent" placement="top-start">
      <div class="file_name_box">{{ getFileName(fileData.path || fileData.msgContent) }}</div>
    </el-tooltip>

    <div class="icon" :class="file_type_className"></div>
  </div>
</template>

<script setup>
import { getFileName } from '@/utils/util';
import { computed } from 'vue';
const props = defineProps({
  fileData:{
    type: Object,
    default:()=>({})
  }
})

const file_type_className = computed(()=>{
  return getFileType(props.fileData.path || props.fileData.msgContent)
})
const getFileType = (fileName = '') => {
      let type = (
        fileName.match(/(.+)\.(\w+)$/) ? fileName.match(/(.+)\.(\w+)$/)[2] : ''
      ).toLowerCase();
      switch (type) {
        case 'png':
        case 'jpg':
        case 'jpeg':
          return 'file_other';
        case 'doc':
        case 'docx':
          return 'file_word';
        case 'ppt':
        case 'pptx':
          return 'file_ppt';
        case 'xls':
        case 'xlsx':
          return 'file_excel';
        case 'txt':
          return 'file_txt';
        case 'xmind':
          return 'file_xmind';
        case 'zip':
          return 'file_zip';
        case 'pdf':
          return 'file_pdf';
        default:
          return 'file_other';
      }
    }
</script>

<style lang="less" scoped>
.file_card {
  max-width: 160px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1;
  padding:10px;
  box-shadow: 0 0 4px 0 #ccc;
  background-color: #fff;
  margin: 5px 0;
  border-radius: 5px;

  .icon {
    width: 35px;
    height: 35px;
    // background: url('@/assets/file_icon.png') no-repeat;
    // background-size: contain;
  }

  .file_name_box {
    width: 140px;
    display: block;
    word-break: break-all;
    word-wrap: break-word;
    overflow-wrap: anywhere;
  }
}
</style>